module.exports = function(translate) {
  INKIVE.C.DEFAULT_FINEUPLOADER.messages.typeError = '{file} has an invalid extension. Valid extension(s): {extensions}.';

  INKIVE.C.TextDefault = [
    {
      text       : translate('text.option_title'),
      fontFamily : 'Lato',
      fontSize   : '45',
      size       : 0.18
    },
    {
      text       : translate('text.option_subtitle'),
      fontFamily : 'Lato',
      fontSize   : '30',
      size       : 0.1
    },
    {
      text       : translate('text.option_body'),
      fontFamily : 'Lato',
      fontSize   : '20',
      size       : 0.04
    },
    {
      text       : translate('text.option_text_block'),
      fontFamily : 'Lato',
      fontSize   : '15',
      size       : 0.03,
      textBlock  : 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua.'
    }
  ];

  INKIVE.C.HTML = {
    breadcrumbWrapper: '<ul class="breadcrumb"><li></li></ul>',

    breadcrumbElement: function(href, className, name) {
      return '<a data-toggle="tab" href="#' + href + '" class="' + className + '">' + name + ' </a>&gt '
    },

    progressBar: function(id) {
      if(!id) console.error('INKIVE.C.HTML.progressBar: id is not defined');

      return $.parseHTML('<div class="progress-wrapper" id="' + id + '">'
      + '<div class="progress"><div class="progress-bar" role="progressbar" style="width: 0%;">0%</div></div>'
      + '<a class="btn progress-cancel"><i class="desygner-icon-close"></i></a></div>');
    }
  };
};
